import Searches from './Searches'

export const SearchesService = Searches
